import {useRole} from "../../hooks/useRole";
const {isBrand} = useRole()

export default async function authenticated({next, router}) {
  if (isBrand.value) {
    return next();
  }

  router.push({name: 'dashboard'});
  return false;
}
